import type { Reference, ServiceRequest } from '@medplum/fhirtypes'
import * as codeSystems from '@seen/core/codeSystems'
import { buildElationUrlFeedItem, extractElationId } from '@seen/core/elation'
import type * as appointments from '@seen/core/models/appointments/index'
import { useConfig } from '#src/contexts/config/useConfig.ts'
import { useFhirSearchOne } from '#src/hooks/useFhirSearchOne.ts'
import { useResource } from '#src/hooks/useResource.ts'

export function useElationFeedItemReferralOrderFromAppointmentUrl(
  appointment?: appointments.ExtendedAppointment
): string | undefined {
  const { data: participant } = useResource(appointment?.patient)
  const elationPatientId = participant && extractElationId(participant)
  return useElationFeedItemReferralOrderFromServiceRequest(
    appointment?.basedOn?.[0],
    elationPatientId
  )
}

export function useElationFeedItemReferralOrderFromServiceRequest(
  basedOn?: Reference<ServiceRequest> | ServiceRequest,
  elationPatientId?: number | string
): string | undefined {
  const { elationBaseUrl } = useConfig()
  const {
    query: { data: communication },
  } = useFhirSearchOne(
    'Communication',
    {
      'based-on': basedOn,
      identifier: `${codeSystems.ELATION_SANDBOX_ID_SYSTEM}|`,
    },
    { query: { enabled: !!basedOn } }
  )
  // The elation feed item ID for the referral is not the referral order ID but rather the letter ID
  // https://docs.elationhealth.com/reference/the-referral-order-object
  // https://docs.elationhealth.com/reference/the-letter-object
  const elationFeedItemId = communication && extractElationId(communication)
  return elationFeedItemId && elationPatientId
    ? buildElationUrlFeedItem({
        elationBaseUrl,
        elationPatientId,
        elationFeedItemId,
      })
    : undefined
}
